import { Box, Typography } from '@mui/material';
import React from 'react';
import Text from '../../shared/Text';
import CommonStaticLayout from './common-static-layout';

const NotAuthorizedForIncydr: React.FC = () => (
  <CommonStaticLayout>
    <Box display="flex" flexDirection="column" gap="16px">
      <Typography variant="h1">
        <strong>{Text.get('login_unauthorized_incydr_header')}</strong>
      </Typography>
      <Typography variant="body1" mb={0.75}>
        {Text.get('login_unauthorized_incydr_desc_1')}
      </Typography>
      <Typography variant="body1">{Text.get('login_unauthorized_incydr_desc_2')}</Typography>
    </Box>
  </CommonStaticLayout>
);

export default NotAuthorizedForIncydr;
